var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-green-dark"},[_c('div',{staticClass:"container mx-auto xl:px-8 py-6"},[_c('div',{staticClass:"flex flex-wrap items-center"})])])
}]

export { render, staticRenderFns }